import React from 'react';
import { StepComponent } from './Step';
import {
	VideoSelectionStep,
	GeneralInformationStep,
	EvaluationControlStep,
	ActionPlanStep,
	ResultStep
} from './Step/components';
import { Step } from './types';

export function Container(): JSX.Element {
	const steps: Step[] = [
		{
			id: '1',
			sequence: 1,
			name: 'Video Selection',
			description: 'Video Selection',
			component: <VideoSelectionStep />
		},
		{
			id: '2',
			sequence: 2,
			name: 'General Information',
			description: 'General Information',
			component: <GeneralInformationStep />
		},
		{
			id: '3',
			sequence: 3,
			name: 'Evaluation',
			description: 'Evaluation',
			component: <EvaluationControlStep />
		},
		{
			id: '4',
			sequence: 4,
			name: 'Action Plan',
			description: 'Action Plan',
			component: <ActionPlanStep />
		},
		{
			id: '5',
			sequence: 5,
			name: 'Result',
			description: 'Result',
			component: <ResultStep />
		}
	];

	return <StepComponent steps={steps} />;
}
